import {Col, Container, Row} from "react-bootstrap";
import React, {useEffect} from "react";
import ImgPlaceholder from "../../assets/img/placeholder.png";

const Profiles = (props) => {

    useEffect(() => {

        const allAssociations = props.profiles?.flatMap(profile =>
            profile.associations.map(assoc => ({...assoc, profile}))
        ) || [];

        if (allAssociations.length === 1) {
            const single = allAssociations[0];
            // Salviamo l'ID
            localStorage.setItem("associationID", single.association_id);
            // Eseguiamo il click automatico
            handleProfileClick({
                profile_name: single.profile.first_name,
                profile_id: single.profile.profile_id,
                association: single.association_id,
                association_name: single.association_name,
                email: single.profile.email,
                season: single.current_season,
                permissions: single.permissions,
                roles: single.roles,
            });
        }
    }, [props.profiles]);

    const handleProfileClick = (profile) => {
        props.onSelectProfile(profile);
        console.log(profile);
    };

    return (
        <Container
            fluid
            className="mw-100 mx-0 p-0 h-100 px-0 bgLogin align-content-center"
            style={{height: "100vh", overflowX: "hidden", overflowY: "auto"}}
        >
            <Row className="justify-content-center text-center align-content-center">
                <Col md={12} className="mb-2 text-white">
                    <h2>Seleziona il profilo</h2>
                </Col>

                {/* Contenitore scrollabile */}
                <div
                    className="w-100 px-3"
                    style={{
                        overflowY: "auto",
                        maxHeight: "calc(100vh - 100px)",
                        paddingBottom: "2rem",
                    }}
                >
                    <Row className="justify-content-center">
                        {props.profiles &&
                            props.profiles.map((profile) =>
                                profile.associations.map((association) => (
                                    <Col
                                        md={3}
                                        key={association.association_id}
                                        className="bkg-primary m-2 text-white text-center cursor-pointer p-5 rounded-5 border border-4 border-white"
                                        onClick={() => {
                                            localStorage.setItem(
                                                "associationID",
                                                association.association_id
                                            );
                                            handleProfileClick({
                                                profile_name: profile.first_name,
                                                profile_id: profile.profile_id,
                                                association: association.association_id,
                                                association_name: association.association_name,
                                                email: profile.email,
                                                season: association.current_season,
                                                permissions: association.permissions,
                                                roles: association.roles,
                                            });
                                        }}
                                    >
                                        <p>
                                            <img
                                                src={ImgPlaceholder}
                                                width={"100px"}
                                                className="img-fluid"
                                                alt="placeholder"
                                            />
                                        </p>
                                        <p>
                                            Profilo: {profile.first_name} <br/>
                                            Associazione: {association.association_name}
                                        </p>
                                    </Col>
                                ))
                            )}
                    </Row>
                </div>
            </Row>
        </Container>
    );
};

export default Profiles;
